

































import {Component, Mixins, Prop, Watch} from "vue-property-decorator";
import {Meeting} from "@api/models/meetings/Meeting";
import {Element} from "@api/models/Element";
import {RepositoryFabric} from "@api/repositories/RepositoryFabric";
import {UserProfile} from "@api/models/UserProfile";
import User from './User.vue';
import {stateKey} from "@share/web-conferences/helpers/StateKey";
import {PresentersList} from "@share/web-conferences/types/PresentersList";
import {PresenterStatusChange} from "@share/web-conferences/types/PresenterStatusChange";
import {WebConferenceRepository} from "@api/repositories/WebConferenceRepository";
import {
    joinedUserIdsGetter,
    presentersGetter,
    raisedHandUsersGetter,
    removedSpeakersGetter
} from "@share/web-conferences/store/getters";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import {Debounce} from "vue-debounce-decorator";
import {isBottom as isBottomFn} from "@common/isBottom";
import {EventBus} from "@common/EventBus";
import {EventTypes, getEventKey} from "@share/web-conferences/helpers/EventBusHelper";
import SearchBar from "./SearchBar.vue";
import IsParticipantsLimited from "@mixins/isParticipantsLimited";
import {groupFilter} from "@api/helpers/groupFilter";
import {UserProfilesService} from "@share/web-conferences/data/people/UserProfilesService";
import {isProfileInTheList} from "@share/web-conferences/helpers/SearchHelper";
import {StreamInfo} from "@share/web-conferences/types/StreamInfo";
import {OnlineCounter} from "@mixins/OnlineCounter";
import {CurrentPresentation} from "@api/models/interfaces/web-conference/CurrentPresentation";
import { MessageType, NoticeProxy } from "@service/components/notice-hub/helpers/NoticeProxy";
import { NoticeState } from "@service/store/types/NoticeState";
import { Modal } from "@common/Modal";

export interface PeopleManagementParams {
  onlyOnline?: boolean;
  initOnMount?: boolean;
}

//@todo move data workload to a separated class
@Component({
    name: "PeopleManagement",
    components: {SearchBar, BounceSpinner, User}
})
export default class PeopleManagement extends Mixins(IsParticipantsLimited, OnlineCounter) {
  @Prop() schemaId: string;
  @Prop() element: Meeting | Element;
  @Prop({default: []}) speakers: UserProfile[];
  @Prop({ default: 'general'}) usersCounterId: string;
  @Prop({}) params: PeopleManagementParams | undefined;

  private readonly maxPresentersNumber: number = parseInt(process.env.VUE_APP_PRESENTERS_LIMIT || '12');

  userProfileService: UserProfilesService | null = null;
  webConferenceRepository: WebConferenceRepository = this.$repositories.get(RepositoryFabric.WEB_CONFERENCE);
  onlineCounterTake = -1;

  fetchingProfiles = false;
  isLoading = true;
  profiles: UserProfile[] = [];
  foundProfiles: UserProfile[] = [];
  stateKey = '';
  presentersProfiles: UserProfile[] = [];
  presenters: PresentersList = {};
  usersBeingProcessed: number[] = [];
  pageLimit = 20;
  searchStr = '';
  previousSearchStr = '';
  speakerIds: number[] = [];
  currentPresentation: CurrentPresentation | null = null;
  isTurningOffSharing = false;

  eventBusEvents: Record<string, any> = {
      [EventTypes.playerInitialized]: this.init,
      [EventTypes.sharingChanged]: this.onSharingChanged
  }

  get isOwner() {
    return this.ownerUserId === this.userId
  }

  get ownerUserId() {
    return this.element?.ownerId;
  }

  private get userId() {
    return this.$store.state.session.userId;
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  get currentUserProfile(): UserProfile {
    return this.$store.getters.profile;
  }

  get onlineUserIds(): number[] {
    return this.counter?.userIds || [];
  }

  get joinedWebinarUserId() {
    return this.$store.getters[joinedUserIdsGetter](this.stateKey);
  }

  get presenterFromStore(): UserProfile[] {
    return this.$store.getters[presentersGetter](this.stateKey) ?? [];
  }

  get raisedHandUsers(): UserProfile[] {
    return this.$store.getters[raisedHandUsersGetter](this.stateKey) ?? [];
  }

  get raisedHandUsersState() {
    return this.$store.state.webConference.raisedHandUsers[this.stateKey];
  }

  @Watch('raisedHandUsersState')
  watchRaisedHandUsersState(current: UserProfile[] | undefined, prev: UserProfile[] | undefined) {
    if(prev && current && (prev.length < current.length) && current.length > 0) {

      const groupId = `${this.stateKey}@${MessageType.raiseHand}`;
      const profile = current[current.length - 1]
      const userExistInGroup = this.noticeState.groups[groupId]?.find(notice => notice.key === profile.userId)

      if(userExistInGroup) {return;}

      const noticeProxy = this.$store.getters['notice/proxy'] as NoticeProxy | null;
      if(noticeProxy) {
        noticeProxy.submitGroupedNotice<UserProfile>([profile], MessageType.raiseHand, groupId)
      }
    }
  }

  get noticeState(): NoticeState {
    return this.$store.state.notice
  }

  get raisedHandUsersIds() {
    return this.raisedHandUsers.map(item => item.userId);
  }

  get eventId() {
    return this.$store.state.events.selected;
  }

  get listToRender() {
    return this.searchStr
        ? this.foundProfiles
        : [...this.presentersProfiles, ...this.profiles]
            .filter(profile => this.needToBeShownInTheList(profile.userId as number));
  }

  get onlineUsersCounterId() {
    return this.usersCounterId;
  }

   get removedSpeakers(): number[] {
       return this.$store.getters[removedSpeakersGetter](this.stateKey) ?? [];
   }

  get maxPresentersNumberMaxedOut() {
      const presentersUsersIds = Object.entries(this.presenters).filter(item => item[1]).map(item => parseInt(item[0]));
      const speakerIds = this.speakerIds.filter(item => this.removedSpeakers.indexOf(item) < 0);

      return [...new Set([...presentersUsersIds, ...speakerIds])].length >= this.maxPresentersNumber;
  }

  async mounted() {
    this.stateKey = stateKey(this.schemaId, this.element.id);
    this.switchEventBusEvent();

    if(this.params?.initOnMount) {
      this.init()
    }
  }

  switchEventBusEvent(switchOn = true) {
      for (const [eventType, listener] of Object.entries(this.eventBusEvents)) {
          const eventKey = getEventKey(eventType, this.schemaId, this.element.id);
          if (switchOn) {
              EventBus.$on(eventKey, listener);
          }
          else {
              EventBus.$off(eventKey, listener);
          }
      }

  }

  async init() {
    try {
      this.userProfileService = new UserProfilesService(
        this.eventId,
        groupFilter(this.participantsGroupIds()),
        this.$repositories.get(RepositoryFabric.USER),
        this.$store
      );
      this.preparePresentersProfiles();
      await this.subscribeToOnlineUsersUpdate();
      if (this.raisedHandUsers && this.raisedHandUsers.length) {
          this.profiles = [...this.raisedHandUsers];
      }
      await this.fetchOnlineUsers();
      (this.$el as HTMLElement).addEventListener('scroll', this.scrollHandler);
      this.speakerIds = this.speakers.map(item => item.userId as number);
    }
    catch(e) {
      this.$store.dispatch('reportError', e);
    }
    finally {
      this.isLoading = false;
    }
  }

  needToBeShownInTheList(userId: number) {
      if(this.params?.onlyOnline) {
        return this.joinedWebinarUserId.includes(userId);
      }
      else {
        return this.speakerIds.includes(userId) ||
             this.presenters[userId] ||
             this.raisedHandUsersIds.includes(userId) ||
             this.onlineUserIds.includes(userId);
      }
  }

  preparePresentersProfiles() {
    if (this.schemaId == 'Meetings') {
      this.presentersProfiles = [...(this.element as Meeting).participants];
    }

    if (this.speakers) {
      this.presentersProfiles = [...this.speakers];
    }

    this.presentersProfiles = [
      ...this.presentersProfiles,
      ...this.presenterFromStore.filter(presenter => this.presentersProfiles.findIndex(item => item.userId == presenter.userId) < 0)
    ];

    if (this.currentUserProfile && !isProfileInTheList(this.presentersProfiles, this.currentUserProfile)) {
      this.presentersProfiles.push(this.currentUserProfile);
    }

    if (this.isAdmin) {
      this.sortPresenters();
    }

    this.speakers.forEach(item => {
       this.$set(this.presenters, item.userId as number, !this.removedSpeakers.includes(item.userId as number));
    });

    this.presenterFromStore.forEach(profile => {
      this.$set(this.presenters, profile.userId as number, true);
    });
  }

  sortPresenters() {
    this.presentersProfiles = this.presentersProfiles.sort((a,b) => {
      if (a.userId && a.userId == this.currentUserProfile.userId) {
        return -1
      }
      return 1;
    });
  }

  sortProfiles() {
    this.profiles = this.profiles.sort((a,b) => {
      if (a.userId && this.raisedHandUsersIds.indexOf(a.userId) >= 0) {
        return -1
      }
      return 1;
    });
  }

  @Watch('presenterFromStore')
  @Debounce(300)
  onPresenterFromStoreChanged(newValue: UserProfile[], oldValue: UserProfile[]) {
    this.presenterFromStore.forEach(item => {
      this.moveToPresentersList(item);
    })

    const deletedPresenters = oldValue.filter(item => newValue.findIndex(profile => profile.userId == item.userId) < 0);

    deletedPresenters.forEach(item => {
      this.moveToAudienceList(item)
    });

    this.sortPresenters();
  }

  @Watch('raisedHandUsersIds')
  @Debounce(300)
  onRaisedHandChanged() {
    if (this.isLoading)  {
      return;
    }

    this.raisedHandUsers.forEach(raisedHandUser => {
      if (!isProfileInTheList(this.profiles, raisedHandUser) && !isProfileInTheList(this.presentersProfiles, raisedHandUser)) {
        this.profiles.push(raisedHandUser);
      }
    });

    this.sortProfiles();
  }

  @Watch('onlineUserIds')
  @Debounce(300)
  onOnlineUserIdsChanged() {
    // this.profiles = this.profiles.filter(item => this.onlineUserIds.indexOf(item.userId as number) >= 0);

    if (this.profiles.length < this.pageLimit) {
      this.fetchOnlineUsers();
    }
  }

  async onLiveChange(data: PresenterStatusChange) {
    try {
      this.usersBeingProcessed.push(data.user.userId as number);

      if (data.isPresenter) {
        await this.webConferenceRepository.addPresenter(this.schemaId, this.element.id, data.user.userId as number);
        this.moveToPresentersList(data.user);
      } else {
        await this.webConferenceRepository.deletePresenter(this.schemaId, this.element.id, data.user.userId as number);
        this.moveToAudienceList(data.user);
      }

      this.usersBeingProcessed.splice(this.usersBeingProcessed.indexOf(data.user.userId as number), 1);
    }
    catch (e) {
      this.$store.dispatch('reportError', e);
    }
  }

  moveToPresentersList(profile: UserProfile) {
    this.$set(this.presenters, profile.userId as number, true);
    !isProfileInTheList(this.presentersProfiles, profile) && this.presentersProfiles.push(profile);
    this.profiles = this.profiles.filter(item => item.userId != profile.userId);
  }

  moveToAudienceList(profile: UserProfile) {
    this.$set(this.presenters, profile.userId as number, false);
    const shouldBeInSpeakersList = isProfileInTheList(this.speakers, profile)
                                  || profile.userId == this.currentUserProfile.userId;

    if (!shouldBeInSpeakersList) {
      !isProfileInTheList(this.profiles, profile) && this.profiles.push(profile);
      this.presentersProfiles = this.presentersProfiles.filter(item => item.userId != profile.userId);
    }
  }

  @Debounce(300)
  scrollHandler() {
    if (!this.fetchingProfiles && !this.isLoading) {
      if (isBottomFn(this.$el as HTMLElement)) {
        if (this.searchStr && this.searchStr.length) {
          this.searchProfiles();
        }
        else {
          this.fetchOnlineUsers();
        }
      }
    }
  }

  async fetchOnlineUsers() {
      if (this.fetchingProfiles) {
          return;
      }

      this.fetchingProfiles = true;

      const alreadyLoaded = [...this.presentersProfiles.map(item => item.userId), ...this.profiles.map(item => item.userId), ...[this.currentUserProfile.userId]];
      const filteredOnlineUsers = this.onlineUserIds.filter(item => alreadyLoaded.indexOf(item) < 0).slice(0, this.pageLimit);

      if (filteredOnlineUsers && filteredOnlineUsers.length) {
        const newProfiles = (await this.userProfileService?.fetchOnlineUsers(filteredOnlineUsers) as UserProfile[] || []).filter((item: UserProfile) => !isProfileInTheList(this.profiles, item));
        this.profiles = [...this.profiles, ...newProfiles];
      }

      this.fetchingProfiles = false;
  }

  async searchProfiles() {
    this.fetchingProfiles = true;

    const profiles = await this.userProfileService?.searchProfiles(this.searchStr, this.pageLimit, this.foundProfiles.length) as UserProfile[];

    if (this.searchStr === this.previousSearchStr) {
      this.foundProfiles = [...this.foundProfiles, ...profiles];
    }
    else {
      this.foundProfiles = profiles;
    }

    this.previousSearchStr = this.searchStr;

    this.fetchingProfiles = false;
  }


  @Debounce(500)
  @Watch('searchStr')
  onSearchChange() {
    if (this.searchStr && this.searchStr) {
      this.searchProfiles();
    }
    else {
      this.foundProfiles = [];
    }

    this.$nextTick(() => {
      (this.$el as HTMLElement).scrollTo({
        top: 0
      });
    })
  }

  async ban(profile: UserProfile) {
    const modal = new Modal({
      title: this.$t('common.warningTitle').toString(),
      contentText: this.$t('web-conferences.banConfirmTitle').toString(),
      buttons: [
        {
          text: this.$t('common.yes').toString(),
          class: 'is-red',
          returnValue: true
        },
        {
          text: this.$t('common.no').toString(),
          class: 'is-green is-outlined',
          returnValue: false
        },
      ]
    });

    const confirmResult = await modal.showConfirm();
    if (confirmResult === true) {
      try {
        this.webConferenceRepository.ban(this.schemaId, this.element.id, profile.userId as number);
      }
      catch(e) {
        this.$store.dispatch("reportError", e);
      }
    }
  }

  async onStreamChanged(streamInfo: StreamInfo) {
    try {
      await this.webConferenceRepository.streamStatus(this.schemaId, this.element.id, streamInfo);
    }
    catch(e) {
      this.$store.dispatch("reportError", e);
    }
  }

  async onSharingChanged(currentPresentation: CurrentPresentation | null) {
      this.currentPresentation = currentPresentation;
  }

  async onTurnOffSharing() {
        if (this.isTurningOffSharing) {return;}

        this.isTurningOffSharing = true;
        try {
            await this.webConferenceRepository.changePresentation(this.schemaId, this.element.id, null);
            this.currentPresentation = null;
        }
        catch (e) {
            this.$store.dispatch('reportError', e);
        }
        finally {
            this.isTurningOffSharing = false;
        }
  }

  beforeDestroy() {
    (this.$el as HTMLElement).removeEventListener('scroll', this.scrollHandler);
    this.switchEventBusEvent(false);
    this.unsubscribeFromOnlineUsersUpdate();
  }
}
